module.exports = __webpack_public_path__ + "img/arrow-right.ad79e741.svg";